import { paddingXXL } from "src/styles/spacing";

export const NAV_BAR_HEIGHT = paddingXXL * 2 + 32; // Vertical padding + icon height
export const NAV_BAR_LOGO_SIZE = 48;
